import colors from "../../base/colors";
import typography from "../../base/typography";

import pxToRem from "../../functions/pxToRem";

const { info, inputBorderColor, dark, grey } = colors;
const { size } = typography;

const input = {
  styleOverrides: {
    root: {
      fontSize: size.sm,
      color: dark.main,

      "&:hover:not(.Mui-disabled):before": {
        borderBottom: `1px solid ${grey[400]}`,
      },

      "&:before": {
        borderColor: inputBorderColor,
        transition: "border-bottom-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      },

      "&:after": {
        borderColor: info.main,
        borderWidth: "2px",
        transition: "border-bottom-color 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
      },

      "&.Mui-focused": {
        "& .MuiInputLabel-root": {
          color: info.main,
        },
      },

      "&.Mui-error": {
        "&:after": {
          borderColor: colors.error.main,
        },
        "& .MuiInputLabel-root": {
          color: colors.error.main,
        },
      },
    },

    input: {
      color: dark.main,
      padding: `${pxToRem(10)} 0`,
      fontSize: size.sm,
      lineHeight: "1.5",

      "&::placeholder": {
        color: grey[500],
        opacity: 1,
      },

      "&:focus": {
        outline: "none",
      },
    },

    inputSizeSmall: {
      padding: `${pxToRem(8)} 0`,
      fontSize: size.xs,
    },
  },
};

export default input;
